import { TAppState } from '../../types/appState';

export function socketSelector(state: TAppState) {
  return state.socket;
}
